import { Banner, secondaryColors } from '@tryhackme/thm-ui-components';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledBanner = styled(Banner)`
  height: unset;
  padding: 0 1.6rem;
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 7.2rem;
  margin: 4rem 0;
`;

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  text-decoration: none;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${secondaryColors.grey[500]};

  &:hover {
    color: ${secondaryColors.grey[200]};
  }
`;

export const StyledTitle = styled.h1`
  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  color: ${({ theme }) => theme.colors.grey['100']};
  margin: 0;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 5.4rem;
  }
`;

export const StyledDescription = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  line-height: 2.6rem;
  color: ${secondaryColors.grey[200]};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 2rem;
  }
`;

export const StyledMobileImage = styled.img`
  display: block;
  width: 7.4rem;
  height: 7.4rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 8.6rem;
    height: 8.6rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: none;
  }
`;

export const StyledDesktopImage = styled.img`
  width: 30.3rem;
  height: 30.3rem;
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: block;
  }
`;
